module.exports = __webpack_public_path__ + "app-static/img/hbsb.24d442a8.png";